import React from 'react';

import { DigitalDataView } from 'types';
import { PageKey, SortOrder } from 'enums';

import { LentTable } from '../lent-table';
import { fetchTableItems } from '../lent-api';
import { lentHistoryRegisteredColumns } from '../lent-columns';

const fetchFunction = fetchTableItems<DigitalDataView>(
  '/api/digital-data-view/my-views'
);

export function LentHistoryTableRegistered() {
  return (
    <LentTable<DigitalDataView>
      title="Prohlédnuté archiválie pro přihlášené"
      pageKey={PageKey.PORTFOLIO_LENT_HISTORY_REGISTERED}
      columns={lentHistoryRegisteredColumns}
      fetchFunction={fetchFunction}
      params={{
        sort: [
          { field: 'archivalUnitReference.numericId', order: SortOrder.ASC },
        ],
      }}
    />
  );
}
